import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  AspectRatio,
  Box,
  ListItem,
  OrderedList,
  SimpleGrid,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";

import { Seo } from "../Components/Seo";
import { seoThumbnailUrl } from "../Components/imagesLink";

const Help = () => {
  return (
    <>
      <Seo
        title="Help - WpCalendar | Whatsapp chat to calendar events!"
        description="Effortlessly convert WhatsApp chat events to calendar events with our privacy-conscious tool. Keep track of important dates without compromising your data privacy."
        type="website"
        name="Soham_UltraHopeful"
        url="https://wpcalendar.vercel.app/help"
        imageUrl={seoThumbnailUrl}
      />
      <SimpleGrid SimpleGrid columns={1} spacing={[10, 8, 5]} p={5}>
        <Stack>
          <Text fontSize="2xl" fontWeight={"bold"}>
            Frequently Asked Questions
          </Text>
          <Accordion defaultIndex={[0]}>
            <AccordionItem>
              <h2>
                <AccordionButton _expanded={{ bg: "blue.400", color: "white" }}>
                  <Box as="span" flex="1" textAlign="left">
                    1. How to use tool?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Text fontSize="md">
                  Here is the brief video to understand all the steps
                </Text>
                <AspectRatio
                  ratio={16 / 9}
                  maxW={{ base: "sm", md: "xl", lg: "2xl" }}
                >
                  <iframe
                    src="https://www.youtube.com/embed/SlgNCIRjUUs"
                    title="How to use WpCalendar -Whatsapp Chat to calendar events tool"
                    frameborder="0"
                    style={{ borderRadius: "5px" }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </AspectRatio>
                <br />
                <Text fontSize="md">
                  <b>Step 1</b> - How to <b>export chat</b> from WhatsApp Follow
                  below steps:
                </Text>
                <OrderedList px={7}>
                  <ListItem>click on top-right 3 dots</ListItem>
                  <ListItem>Select more option</ListItem>
                  <ListItem>
                    Select <b>export chats</b>
                  </ListItem>
                  <ListItem>
                    Select <b>without media</b> option
                  </ListItem>
                  <ListItem>
                    Send .txt file to yourself in Whatsapp or Email
                  </ListItem>
                </OrderedList>
                <br />
                <Text fontSize="md">
                  <b>Step 2</b> - How to <b>generate calendar file</b> Follow
                  below steps:
                </Text>
                <OrderedList px={7}>
                  <ListItem>Select the Whatsapp chat export .txt file</ListItem>
                  <ListItem>Enter Whatsapp username in input field</ListItem>
                  <ListItem>
                    <b>Edit/Delete</b> Birthday or Anniversary event as required
                  </ListItem>
                  <ListItem>Download the generated .ics file</ListItem>
                </OrderedList>
                <br />
                <Text fontSize="md">
                  <b>Step 3</b> - How to <b>import events</b> to google calendar
                  Follow below steps:
                </Text>
                <VStack alignItems={"flex-start"}>
                  <Text fontSize="md">
                    Before Export please create new calendar to export this
                    events into that new calendar to delete all the events
                    anytime in future
                  </Text>
                  <OrderedList px={7}>
                    <ListItem>
                      Left-hand Side in Google Calendar Other Calendars click on
                      + sign
                    </ListItem>
                    <ListItem>Select option "Create new calendar"</ListItem>
                    <ListItem>Write the name you want</ListItem>
                  </OrderedList>
                  <Text fontSize="md">
                    To <b>export events to google calendar </b>Follow below
                    steps:
                  </Text>
                  <OrderedList px={7}>
                    <ListItem>Go to settings</ListItem>
                    <ListItem>Select Import & Exports</ListItem>
                    <ListItem>Select new calendar you created</ListItem>
                    <ListItem>Go to import</ListItem>
                    <ListItem>
                      Select the downloaded file and see the magic!!!!
                    </ListItem>
                  </OrderedList>
                </VStack>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <h2>
                <AccordionButton _expanded={{ bg: "blue.400", color: "white" }}>
                  <Box as="span" flex="1" textAlign="left">
                    2. How to <b>add notification</b> to all calendar events in
                    Google calendar?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Text fontSize="md">
                  Here is the brief video to understand all the steps
                </Text>
                <AspectRatio
                  ratio={16 / 9}
                  maxW={{ base: "sm", md: "xl", lg: "2xl" }}
                >
                  <iframe
                    src="https://www.youtube.com/embed/jS7x7kaDhjo"
                    title="How to add notification to all calendar events | WpCalendar"
                    frameborder="0"
                    style={{ borderRadius: "5px" }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </AspectRatio>
                <br />
                <Text fontSize="md">
                  How to <b>add notification</b> to all calendar events in
                  Google calendar. below steps:
                </Text>
                <OrderedList px={7}>
                  <ListItem>Goto setting of the calendar</ListItem>
                  <ListItem>Select event setting</ListItem>
                  <ListItem>Click on add notification</ListItem>
                </OrderedList>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <h2>
                <AccordionButton _expanded={{ bg: "blue.400", color: "white" }}>
                  <Box as="span" flex="1" textAlign="left">
                    3. How to <b>delete</b> all calendar events in Google
                    calendar?
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Text fontSize="md">
                  Here is the brief video to understand all the steps
                </Text>
                <AspectRatio
                  ratio={16 / 9}
                  maxW={{ base: "sm", md: "xl", lg: "2xl" }}
                >
                  <iframe
                    src="https://www.youtube.com/embed/RJV49VjDIR8"
                    title="How to delete all calendar events | WpCalendar"
                    frameborder="0"
                    style={{ borderRadius: "5px" }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </AspectRatio>
                <br />
                <Text fontSize="md">
                  How to <b>delete</b> all calendar events in Google calendar.
                  below steps:
                </Text>
                <OrderedList px={7}>
                  <ListItem>Goto setting of the calendar</ListItem>
                  <ListItem>Scroll to the bottom of page</ListItem>
                  <ListItem>Click on delete calendar</ListItem>
                </OrderedList>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Stack>
      </SimpleGrid>
    </>
  );
};

export default Help;
